import { render, staticRenderFns } from "./TripForm.vue?vue&type=template&id=01f86fe6&scoped=true"
import script from "./TripForm.vue?vue&type=script&lang=js"
export * from "./TripForm.vue?vue&type=script&lang=js"
import style0 from "./TripForm.vue?vue&type=style&index=0&id=01f86fe6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f86fe6",
  null
  
)

export default component.exports